import React from 'react';
export function PricingSection() {
  return <section id="precio" className="py-20 px-5 bg-forest-dark text-center relative overflow-hidden reveal" data-id="element-196">
      <div className="absolute inset-0 bg-pricing-pattern pointer-events-none" data-id="element-197" />

      <div className="relative z-10" data-id="element-198">
        <div className="font-playfair text-[clamp(1.8rem,3.5vw,2.4rem)] font-bold text-cream mb-2" data-id="element-199">
          Empezá hoy mismo
        </div>
        <p className="font-lora italic text-base text-cream/65 mb-10" data-id="element-200">
          Una sola vez. Acceso inmediato. Sin renovaciones.
        </p>

        <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-2xl py-10 px-8 max-w-[500px] mx-auto sm:py-7 sm:px-5" data-id="element-201">
          <div className="text-[0.9rem] text-cream/50 line-through mb-2" data-id="element-202">
            Valor real del programa + bonos: $62.000
          </div>
          <div className="font-playfair text-[clamp(3rem,7vw,4.5rem)] font-black text-cream leading-none mb-1.5" data-id="element-203">
            $17.900
          </div>
          <div className="text-[0.8rem] text-cream/60 mb-7" data-id="element-204">
            Pago único · Acceso inmediato a todo el material
          </div>

          <div className="bg-black/15 rounded-lg py-4 px-5 mb-7 text-left" data-id="element-205">
            <div className="flex justify-between text-[0.83rem] text-cream/70 py-1.5 border-b border-white/5" data-id="element-206">
              <span className="text-[#F5F0E8]" data-id="element-207">
                Programa de Activación Lectora (21 días)
              </span>
              <span className="text-[#F5F0E8]" data-id="element-208">$22.000</span>
            </div>
            <div className="flex justify-between text-[0.83rem] text-cream/70 py-1.5 border-b border-white/5" data-id="element-209">
              <span className="text-[#F5F0E8]" data-id="element-210">
                Bono 1 – Juegos Fonológicos
              </span>
              <span className="text-[#F5F0E8]" data-id="element-211">$15.000</span>
            </div>
            <div className="flex justify-between text-[0.83rem] text-cream/70 py-1.5 border-b border-white/5" data-id="element-212">
              <span className="text-[#F5F0E8]" data-id="element-213">Bono 2 – Calendario Visual</span>
              <span className="text-[#F5F0E8]" data-id="element-214">$15.000</span>
            </div>
            <div className="flex justify-between text-[0.83rem] text-cream/70 py-1.5 border-b border-white/5" data-id="element-215">
              <span className="text-[#F5F0E8]" data-id="element-216">
                Bono 3 – Mini Biblioteca Inicial
              </span>
              <span className="text-[#F5F0E8]" data-id="element-217">$15.000</span>
            </div>
            <div className="flex justify-between text-[0.83rem] text-cream/70 py-1.5 border-b border-white/5" data-id="element-218">
              <span className="text-[#F5F0E8]" data-id="element-219">Bono 4 – Audio Calmante</span>
              <span className="text-[#F5F0E8]" data-id="element-220">$15.000</span>
            </div>
            <div className="flex justify-between text-[0.9rem] text-cream font-semibold border-t border-white/15 mt-1 pt-2.5" data-id="element-221">
              <span data-id="element-222">Hoy pagás</span>
              <span className="text-gold" data-id="element-223">$17.900</span>
            </div>
          </div>

          <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN9M59KdNNduHrWqQMttkBd/es-ar?_r=AQABgGschoRR_SY96W8jodDFHW8nWvDOxXINeW34G_-0IYY&preview_theme_id=163059597347" target="_blank" rel="noopener noreferrer" className="block w-full bg-terracotta text-white font-sans text-base font-medium tracking-[0.06em] uppercase py-5 px-8 rounded text-decoration-none border-none cursor-pointer transition-all duration-200 hover:bg-terracotta-light hover:-translate-y-0.5 mb-4" data-id="element-224">
            QUIERO ACTIVAR LA LECTURA EN CASA →
          </a>

          <div className="text-[0.78rem] text-cream/50 mb-3" data-id="element-225">
            Recibís acceso inmediato por email · Compra protegida por Mercado
            Pago
          </div>

          <div className="flex justify-center gap-5 flex-wrap mt-3" data-id="element-226">
            <span className="text-[0.75rem] text-cream/60 flex items-center gap-1" data-id="element-227">
              🔒 Pago seguro
            </span>
            <span className="text-[0.75rem] text-cream/60 flex items-center gap-1" data-id="element-228">
              📧 Acceso inmediato
            </span>
            <span className="text-[0.75rem] text-cream/60 flex items-center gap-1" data-id="element-229">
              🛡️ Garantía 21 días
            </span>
            <span className="text-[0.75rem] text-cream/60 flex items-center gap-1" data-id="element-230">
              📱 Funciona en celular
            </span>
          </div>
        </div>
      </div>
    </section>;
}